// Auto-generated normalizer for table: CAR_BOOKING.Aprobadores
export function aprobadoresNormalize(row) {
  return {
    idAprobadores: row.idAprobadores ?? row.IdAprobadores ?? row['idAprobadores'] ?? 0,
    idEmpleado: row.idEmpleado ?? row.IdEmpleado ?? row['idEmpleado'] ?? 0,
    idTipoAprobacion: row.idTipoAprobacion ?? row.IdTipoAprobacion ?? row['idTipoAprobacion'] ?? 0,
    activo: row.activo ?? row.Activo ?? row['activo'] ?? false,
    idEmpresa: row.idEmpresa ?? row.IdEmpresa ?? null,
    nombreEmpresa: row.nombreEmpresa ?? row.NombreEmpresa ?? '',
    recibeNotificaciones: row.recibeNotificaciones ?? row.RecibeNotificaciones ?? true,
  };
}